module.exports = __webpack_public_path__ + "img/award5.885de8aa.jpg";